import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Tasks.css';

const PRIORITIES = [
  { value: 'low', label: 'Низкий' },
  { value: 'medium', label: 'Средний' },
  { value: 'high', label: 'Высокий' },
  { value: 'critical', label: 'Критический' },
];

export default function DispatchModal({ projectId, projectTitle, onClose, onDispatched }) {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [dueDate, setDueDate] = useState('');
  const [titleTemplate, setTitleTemplate] = useState('Рассмотреть проект «{project}» и дать заключение — {dept}');
  const [description, setDescription] = useState('');
  const [priority, setPriority] = useState('medium');
  const [filter, setFilter] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        // Все отделы одним махом — с большим page_size, чтобы пагинация DRF не резала
        const res = await api.getDirDepartments({ page_size: 500 });
        const list = res.data.results || res.data;
        setDepartments(list.filter((d) => d.is_active !== false));
      } catch { /* ignore */ }
      setLoading(false);
    })();
  }, []);

  const toggle = (id) => {
    setSelectedIds((s) => {
      const n = new Set(s);
      if (n.has(id)) n.delete(id); else n.add(id);
      return n;
    });
  };

  const selectAll = () => setSelectedIds(new Set(filtered.map((d) => d.id)));
  const clearAll = () => setSelectedIds(new Set());

  const handleSubmit = async () => {
    if (!selectedIds.size) {
      alert('Выберите хотя бы один отдел');
      return;
    }
    setSaving(true);
    try {
      const res = await api.dispatchProjectToDepartments(projectId, {
        department_ids: Array.from(selectedIds),
        due_date: dueDate || null,
        title_template: titleTemplate,
        description,
        priority,
      });
      const created = res.data.created;
      const skipped = res.data.skipped?.length || 0;
      alert(`Создано задач: ${created}${skipped ? `, пропущено: ${skipped}` : ''}`);
      onDispatched && onDispatched();
      onClose();
    } catch (e) {
      alert('Не удалось разослать: ' + (e.response?.data?.detail || e.message));
    }
    setSaving(false);
  };

  const filtered = departments.filter((d) => {
    if (!filter) return true;
    const q = filter.toLowerCase();
    return (d.name_ru || '').toLowerCase().includes(q) || (d.name_uz || '').toLowerCase().includes(q);
  });

  return (
    <div className="tasks-modal-overlay" onClick={onClose}>
      <div className="tasks-modal" style={{ width: 'min(900px, 96vw)' }} onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>📤 Разослать по отделам</h2>
        <p style={{ color: '#6b7280', marginTop: -8 }}>
          Проект: <strong>{projectTitle}</strong>. Для каждого отмеченного отдела создастся задача.
          Исполнителем автоматически станет начальник отдела (или первый активный сотрудник).
        </p>

        <div className="tasks-form-row">
          <label>Шаблон заголовка</label>
          <input className="tasks-input" value={titleTemplate} onChange={(e) => setTitleTemplate(e.target.value)} />
        </div>
        <div style={{ marginLeft: 148, color: '#9ca3af', fontSize: 12, marginBottom: 8 }}>
          Плейсхолдеры: <code>{'{project}'}</code>, <code>{'{dept}'}</code>
        </div>

        <div className="tasks-form-row">
          <label>Описание (общее)</label>
          <textarea className="tasks-textarea" value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>

        <div className="tasks-form-row">
          <label>Общий срок</label>
          <input type="date" className="tasks-input" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
        </div>

        <div className="tasks-form-row">
          <label>Приоритет</label>
          <select className="tasks-select" value={priority} onChange={(e) => setPriority(e.target.value)}>
            {PRIORITIES.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
          </select>
        </div>

        <hr style={{ margin: '16px 0', border: 0, borderTop: '1px solid #e5e7eb' }} />

        <div style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
          <input
            className="tasks-input"
            style={{ maxWidth: 300 }}
            placeholder="Поиск отделов…"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
          <button className="tasks-btn" onClick={selectAll}>Выбрать все ({filtered.length})</button>
          <button className="tasks-btn" onClick={clearAll}>Снять выделение</button>
          <span style={{ marginLeft: 'auto', color: '#6b7280' }}>Выбрано: <strong>{selectedIds.size}</strong></span>
        </div>

        {loading ? (
          <div className="tasks-empty">Загрузка отделов…</div>
        ) : (
          <div style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 6, padding: 8 }}>
            {filtered.map((d) => (
              <label key={d.id} style={{ display: 'flex', alignItems: 'center', padding: '4px 8px', cursor: 'pointer', borderRadius: 4 }}>
                <input
                  type="checkbox"
                  checked={selectedIds.has(d.id)}
                  onChange={() => toggle(d.id)}
                  style={{ marginRight: 8 }}
                />
                <span>{d.name_uz || d.name_ru}</span>
                {d.code && <span style={{ marginLeft: 'auto', color: '#9ca3af', fontSize: 12 }}>{d.code}</span>}
              </label>
            ))}
          </div>
        )}

        <div className="tasks-form-actions">
          <button className="tasks-btn" onClick={onClose}>Отмена</button>
          <button className="tasks-btn primary" onClick={handleSubmit} disabled={saving || !selectedIds.size}>
            {saving ? 'Отправка…' : `Разослать (${selectedIds.size} отделов)`}
          </button>
        </div>
      </div>
    </div>
  );
}
